import http from '../../../../libs/http'
import config from '../../../../config/shops'
export default (id) => http.post(`${config.api}/orders/${id}/transfer`)
